import React from 'react';
import classes from './Input.module.css';

const Input = ({
    label,
    name,
    id,
    type = 'text',
    placeholder,
    onClick,
    onChange,
    onBlur,
    onFocus,
    value,
    styles,
    error
  }) => {
  const classesList = [classes.Input];
  
  if (error) {
    classesList.push(classes.Error);
  }
  
  return (
      <div>
        {label ? <label className={classes.Label} htmlFor={name}>{label}</label> : null}
        <input
            className={classesList.join(' ')}
            type={type}
            name={name}
            onClick={onClick}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            value={value}
            id={id}
            placeholder={placeholder}
            style={styles}
        />
      </div>
  );
};

export default Input;